<template>
    <div class="product-sidebar">
        <div class="product-sidebar__top">
            <span class="product-sidebar__top-title">Filter Results</span>
            <a class="product-sidebar__top-close js-close-sidebar" href="javascript:;" @click="closeSideBar"></a>
        </div>
        <div class="product-sidebar__inner">
            <div class="product-sidebar__part-wrap">
                <template v-for="(productType, index) in productType">
                    <div class="product-sidebar__part" :key="index" v-if="productType.links.length > 0">
                        <PartFilterCats @filtersLoad="filtersLoad" :filter="productType" :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap">
                <template v-for="(productCollections, index) in productCollections">
                    <div class="product-sidebar__part" :key="index" v-if="productCollections.links.length > 0">
                        <PartFilterLinks :changeUrl="urlCustom" :filter="productCollections" :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap">
                <template v-for="(productMaterial, index) in productMaterial">
                    <div class="product-sidebar__part product-sidebar__part--margin" :key="index"
                         v-if="productMaterial.material.length > 0">
                        <PartFilterMaterial @filtersLoad="filtersLoad" :productMaterial="productMaterial" :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap">
                <template v-for="(productSize, index) in productSize">
                    <div class="product-sidebar__part product-sidebar__part--margin" :key="index"
                         v-if="productSize.size.length > 0">
                        <PartFilterSize v-if="products" @filtersLoad="filtersLoad" :products="products"
                                        :productSize="productSize"
                                        :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap">
                <template v-for="(productWidth, index) in productWidth">
                    <div class="product-sidebar__part product-sidebar__part--margin" :key="index"
                         v-if="productWidth.width.length > 0">
                        <PartFilterWidth v-if="products" @filtersLoad="filtersLoad" :products="products"
                                         :productWidth="productWidth"
                                         :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap" v-if="isWidthAndLength">
                <template v-for="(productLength, index) in productLength">
                    <div class="product-sidebar__part product-sidebar__part--margin" :key="index"
                         v-if="productLength.productL.length > 0">
                        <PartFilterLength v-if="products" @filtersLoad="filtersLoad" :products="products"
                                          :productLength="productLength"
                                          :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap" v-if="isWidthAndLength">
                <template v-for="(productHeight, index) in productHeight">
                    <div class="product-sidebar__part product-sidebar__part--margin" :key="index"
                         v-if="productHeight.productH.length > 0">
                        <PartFilterHeight v-if="products" @filtersLoad="filtersLoad" :products="products"
                                          :productHeight="productHeight"
                                          :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap" v-if="isWidthAndLength">
                <template v-for="(productDepth, index) in productDepth">
                    <div class="product-sidebar__part product-sidebar__part--margin" :key="index"
                         v-if="productDepth.productD.length > 0">
                        <PartFilterDepth v-if="products" @filtersLoad="filtersLoad" :products="products"
                                         :productDepth="productDepth"
                                         :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap">
                <template v-for="(productStyle, index) in productStyle">
                    <div class="product-sidebar__part" :key="index" v-if="productStyle.links.length > 0">
                        <PartFilterStyle @filtersLoad="filtersLoad" :filter="productStyle" :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap">
                <template v-for="(productBrand, index) in productBrand">
                    <div class="product-sidebar__part" :key="index" v-if="productBrand.links.length > 0">
                        <PartFilterBrands @filtersLoad="filtersLoad" :filter="productBrand" :key="index"/>
                    </div>
                </template>
            </div>
            <div class="product-sidebar__part-wrap">
                <template v-for="(productTypesAttr, index) in productTypesAttr">
                    <div class="product-sidebar__part" :key="index" v-if="productTypesAttr.links.length > 0">
                        <PartFilterTypes @filtersLoad="filtersLoad" :productTypesAttr="productTypesAttr" :key="index"/>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import PartFilterCats from '../parts/PartFilterCats.vue';
import PartFilterLinks from '../parts/PartFilterLinks.vue';
import PartFilterStyle from '../parts/PartFilterStyle.vue';
import PartFilterMaterial from '../parts/PartFilterMaterial.vue';
import PartFilterSize from '../parts/PartFilterSize.vue';
import PartFilterBrands from '../parts/PartFilterBrands.vue';
import PartFilterWidth from '../parts/PartFilterWidth.vue';
import PartFilterLength from '../parts/PartFilterLength.vue';
import PartFilterHeight from '../parts/PartFilterHeight.vue';
import PartFilterTypes from '../parts/PartFilterTypes.vue';
import {EventBus} from '@/vue/store';
import Global from '../../../js/_site/global';
import PartFilterDepth from '../parts/PartFilterDepth';

export default {
    beforeMount() {
        const params = Global.getParamsCookie(Global.readCookie('filters'));
        if (!params) {
            Global.setCookie('activeFilters', []);
        } else {
            if (Object.keys(params).length < 2) {
                const parArr = [];
                for (const param in params) {
                    if (Object.prototype.hasOwnProperty.call(params, param)) {
                        const values = params[param].split('+');
                        for (let i = 0; i < values.length; i++) {
                            const obj = {
                                name: param,
                                val: values[i],
                                addInfo: '',
                                title: param === 'size' ? values[i] : values[i].replace(/-/g, ' '),
                            };
                            parArr.push(obj);
                        }
                    }
                }
                Global.setCookie('activeFilters', parArr);
            }
        }
        this.popstate();
        this.filtersLoad();
    },
    props: ['productType', 'productCollections', 'productStyle', 'productBrand', 'productMaterial', 'productSize', 'productWidth', 'productLength', 'productTypesAttr', 'products', 'productHeight', 'productDepth'],

    components: {
        PartFilterCats,
        PartFilterLinks,
        PartFilterMaterial,
        PartFilterSize,
        PartFilterStyle,
        PartFilterBrands,
        PartFilterWidth,
        PartFilterLength,
        PartFilterHeight,
        PartFilterDepth,
        PartFilterTypes
    },
    methods: {
        popstate() {
            window.addEventListener('popstate', function() {
                if (document.querySelector('.woocommerce-products-container')) {
                    location.reload();
                }
            });
        },
        closeSideBar() {
            const sideBarWrap = document.querySelector('.js-sidebar-wrap');
            const body = document.querySelector('body');

            sideBarWrap.classList.remove('opened-sidebar');
            body.classList.remove('sidebar-opened');
        },

        filtersLoad(event) {
            if (location.search === '') {
                Global.setCookie('filters', '');
            }
            const queryString = Global.getAllUrlParams();
            // if (location.search !== '') {
            //     const allowedQueryKeys = ['size', 'color', 'product_cat', 'width', 'length', 'brand', 'style', 'type'];
            // }
            const getFilters = Global.readCookie('filters');
            let params = '';
            params = Global.getParamsCookie(getFilters);
            const activeFilters = Global.readCookie('activeFilters');
            let color = queryString.color ? queryString.color.split('+') : '';
            let cat = queryString.product_cat ? queryString.product_cat.split('+') : '';
            let size = queryString.size ? queryString.size.split('+') : '';
            // let range = queryString.range ? queryString.range.split('+') : '';
            let width = queryString.width ? queryString.width.split('+') : '';
            let length = queryString.length ? queryString.length.split('+') : '';
            let height = queryString.height ? queryString.height.split('+') : '';
            let depth = queryString.depth ? queryString.depth.split('+') : '';
            let brand = queryString.brand ? queryString.brand.split('+') : '';
            let style = queryString.style ? queryString.style.split('+') : '';
            let type = queryString.type ? queryString.type.split('+') : '';
            let sizeUrl = params.size ? 'size=' + params.size + '&' : '';
            // let rangeUrl = params.range ? 'range=' + params.range + '&' : '';
            let widthUrl = params.width ? 'width=' + params.width + '&' : '';
            let lengthUrl = params.length ? 'length=' + params.length + '&' : '';
            let heightUrl = params.height ? 'height=' + params.height + '&' : '';
            let depthUrl = params.depth ? 'depth=' + params.depth + '&' : '';
            let catUrl = params.product_cat ? 'product_cat=' + params.product_cat + '&' : '';
            let colorUrl = params.color ? 'color=' + params.color + '&' : '';
            let brandUrl = params.brand ? 'brand=' + params.brand + '&' : '';
            let styleUrl = params.style ? 'style=' + params.style + '&' : '';
            let typeUrl = params.type ? 'type=' + params.type + '&' : '';

            if (event) {
                const name = event.target.getAttribute('data-name');
                const valAttr = event.target.getAttribute('data-val');
                const addInfo = name === 'color' ? event.target.getAttribute('data-material') : '';
                const dataRemove = event.target.getAttribute('data-remove');

                if (dataRemove === 'false') {
                    this.pushToFiltersCookie(name, valAttr, addInfo, activeFilters);
                } else {
                    if (name === 'product_cat') {
                        EventBus.$emit('active-filters-after-remove-cat', name);
                    }
                    if (name === 'size') {
                        EventBus.$emit('active-filters-after-remove-size', name);
                    }
                    if (name === 'color') {
                        EventBus.$emit('active-filters-after-remove-color', name);
                    }
                    if (name === 'brand') {
                        EventBus.$emit('active-filters-after-remove-brand', name);
                    }
                    if (name === 'style') {
                        EventBus.$emit('active-filters-after-remove-style', name);
                    }
                    if (name === 'width') {
                        EventBus.$emit('active-filters-after-remove-width', name);
                    }
                    if (name === 'length') {
                        EventBus.$emit('active-filters-after-remove-length', name);
                    }
                    if (name === 'height') {
                        EventBus.$emit('active-filters-after-remove-height', name);
                    }
                    if (name === 'depth') {
                        EventBus.$emit('active-filters-after-remove-depth', name);
                    }
                    if (name === 'type') {
                        EventBus.$emit('active-filters-after-remove-type', name);
                    }
                }

                if (name === 'product_cat' && dataRemove === 'false') {
                    if (cat === '') {
                        cat = [valAttr];
                    } else {
                        const find = cat.filter(el => el === valAttr);
                        if (find.length < 1) {
                            cat.push(valAttr);
                        }
                    }

                    catUrl = cat !== '' ? 'product_cat=' + cat.join('+') + '&' : '';
                }


                if (name === 'size' && dataRemove === 'false') {
                    if (size === '') {
                        size = [valAttr];
                    } else {
                        const find = size.filter(el => el === valAttr);
                        if (find.length < 1) {
                            size.push(valAttr);
                        }
                    }

                    sizeUrl = size !== '' ? 'size=' + size.join('+') + '&' : '';
                }

                // if (name === 'range' && dataRemove === 'false') {
                //   if (range === '') {
                //     range = [valAttr];
                //   } else {
                //     const find = range.filter(el => el === valAttr);
                //     if (find.length < 1) {
                //       range.push(valAttr);
                //     }
                //   }
                //
                //   rangeUrl = range !== '' ? 'size=' + range.join('+') + '&' : '';
                // }

                if (name === 'width' && dataRemove === 'false') {
                    if (width === '') {
                        width = [valAttr];
                    } else {
                        const find = width.filter(el => el === valAttr);
                        if (find.length < 1) {
                            width.push(valAttr);
                        }
                    }

                    widthUrl = width !== '' ? 'width=' + width.join('+') + '&' : '';
                }

                if (name === 'length' && dataRemove === 'false') {
                    if (length === '') {
                        length = [valAttr];
                    } else {
                        const find = length.filter(el => el === valAttr);
                        if (find.length < 1) {
                            length.push(valAttr);
                        }
                    }

                    lengthUrl = length !== '' ? 'length=' + length.join('+') + '&' : '';
                }

                if (name === 'height' && dataRemove === 'false') {
                    if (height === '') {
                        height = [valAttr];
                    } else {
                        const find = height.filter(el => el === valAttr);
                        if (find.length < 1) {
                            height.push(valAttr);
                        }
                    }

                    heightUrl = height !== '' ? 'height=' + height.join('+') + '&' : '';
                }

                if (name === 'depth' && dataRemove === 'false') {
                    if (depth === '') {
                        depth = [valAttr];
                    } else {
                        const find = depth.filter(el => el === valAttr);
                        if (find.length < 1) {
                            depth.push(valAttr);
                        }
                    }

                    depthUrl = depth !== '' ? 'depth=' + depth.join('+') + '&' : '';
                }

                if (name === 'color' && dataRemove === 'false') {
                    if (color === '') {
                        color = [valAttr];
                    } else {
                        const find = color.filter(el => el === valAttr);
                        if (find.length < 1) {
                            color.push(valAttr);
                        }
                    }
                    colorUrl = color !== '' ? 'color=' + color.join('+') + '&' : '';
                }


                if (name === 'brand' && dataRemove === 'false') {
                    if (brand === '') {
                        brand = [valAttr];
                    } else {
                        const find = brand.filter(el => el === valAttr);
                        if (find.length < 1) {
                            brand.push(valAttr);
                        }
                    }
                    brandUrl = brand !== '' ? 'brand=' + brand.join('+') + '&' : '';
                }

                if (name === 'style' && dataRemove === 'false') {
                    if (style === '') {
                        style = [valAttr];
                    } else {
                        const find = style.filter(el => el === valAttr);
                        if (find.length < 1) {
                            style.push(valAttr);
                        }
                    }
                    styleUrl = style !== '' ? 'style=' + style.join('+') + '&' : '';
                }

                if (name === 'type' && dataRemove === 'false') {
                    if (type === '') {
                        type = [valAttr];
                    } else {
                        const find = type.filter(el => el === valAttr);
                        if (find.length < 1) {
                            type.push(valAttr);
                        }
                    }
                    typeUrl = type !== '' ? 'type=' + type.join('+') + '&' : '';
                }
                const params = catUrl + colorUrl + sizeUrl + brandUrl + styleUrl + widthUrl + lengthUrl + typeUrl + heightUrl + depthUrl;
                let symbol = '';
                if (params !== '') {
                    symbol = '?';
                }
                window.history.pushState({}, '', symbol + params.slice(0, -1));
                if (params) {
                    Global.setCookie('filters', params.slice(0, -1));
                }

                this.urlCustom = params.slice(0, -1);
            }

            const productsColl = this.sapData.allProducts;
            let products = [];
            if (this.sapColl !== '') {
                for (const product in productsColl) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (productsColl.hasOwnProperty(product)) {
                        const collections = productsColl[product].collFilters;
                        for (let i = 0; i < collections.length; i++) {
                            if (collections[i] === this.sapColl) {
                                products.push(productsColl[product]);
                            }
                        }
                    }
                }
            } else {
                products = this.sapData.allProducts;
            }
            let filterProducts = [];
            const filterProductsIds = [];
            for (const product in products) {
                // eslint-disable-next-line no-prototype-builtins
                if (products.hasOwnProperty(product)) {

                    const cats = products[product].catFilters;
                    if (cats.length > 0) {
                        const compareCats = this.compare(cat, cats);
                        if (compareCats) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const sizes = products[product].size;
                    if (sizes.length > 0) {
                        for (let sf = 0; sf < sizes.length; sf++) {
                            const compareSize = this.compare(size, [sizes[sf].slug]);
                            // const compareRange = this.compare(range, [sizes[sf].slug]);
                            if (compareSize) {
                                if (!filterProductsIds.includes(product)) {
                                    filterProducts.push(products[product]);
                                }
                                filterProductsIds.push(product);
                            }
                        }
                    }

                    const widths = products[product].width;
                    if (widths.length > 0) {
                        const compareWidths = this.compare(width, widths);
                        if (compareWidths) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const lengths = products[product].length;
                    if (lengths.length > 0) {
                        const compareLengths = this.compare(length, lengths);
                        if (compareLengths) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const heights = products[product].height;
                    if (heights.length > 0) {
                        const compareHeights = this.compare(height, heights);
                        if (compareHeights) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const depths = products[product].depth;
                    if (depths.length > 0) {
                        const compareDepths = this.compare(depth, depths);
                        if (compareDepths) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const colors = products[product].colorFilter;
                    if (colors.length > 0) {
                        const compareColor = this.compare(color, colors);
                        if (compareColor) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const brands = products[product].brandFilter;
                    if (brands.length > 0) {
                        const compareBrand = this.compare(brand, brands);
                        if (compareBrand) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const styles = products[product].styleFilter;
                    if (styles.length > 0) {
                        const compareStyle = this.compare(style, styles);
                        if (compareStyle) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                    const types = products[product].typeFilter;
                    if (types.length > 0) {
                        const compareTypes = this.compare(type, types);
                        if (compareTypes) {
                            if (!filterProductsIds.includes(product)) {
                                filterProducts.push(products[product]);
                            }
                            filterProductsIds.push(product);
                        }
                    }

                }
            }
            let row = {};

            const finalProducts = [];
            if (cat === '' && size === '' && color === '' && style === '' && brand === '' && width === '' && length === '' && type === '' && height === '' && depth === '') {
                for (const product in products) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (products.hasOwnProperty(product)) {
                        filterProducts.push(products[product]);
                    }

                }
            }
            filterProducts = this.singleCollectionOrder(filterProducts);

            if (this.sapCategory !== '') {
                filterProducts = this.singleCategories(filterProducts);
            }

            for (let i = 0; i < filterProducts.length; i++) {
                row[i] = filterProducts[i];
                // finalProducts.push(row);
                if (this.objectLength(row) === 36) {
                    finalProducts.push(row);
                    row = {};
                }
                if (i + 1 === filterProducts.length && this.objectLength(row) > 0) {
                    finalProducts.push(row);
                    row = {};
                }
            }

            // get active colors
            const activeColors = [];
            const activeFiltersForColors = Global.readCookie('activeFilters');
            if (activeFiltersForColors) {
                for (let i = 0; i < activeFiltersForColors.length; i++) {
                    if (activeFiltersForColors[i].name === 'color') {
                        activeColors.push(activeFiltersForColors[i].val);
                    }
                }
                for (let i = 0; i < finalProducts.length; i++) {
                    for (const key in finalProducts[i]) {
                        if (Object.prototype.hasOwnProperty.call(finalProducts[i], key)) {
                            const varObjects = finalProducts[i][key].varImages;
                            if (varObjects) {
                                for (let x = 0; x < varObjects.length; x++) {
                                    if (activeColors.indexOf(varObjects[x].color) !== -1) {
                                        finalProducts[i][key].img = varObjects[x].image;
                                        finalProducts[i][key].url = varObjects[x].url;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.sapData.products = finalProducts;
            this.sapData.productsRow = this.sapData.products[0];
            this.sapData.pagination.total = this.sapData.products.length;
            this.sapData.productsCount = filterProducts.length;
            this.reducingFilters(filterProducts);
        },

        singleCollectionOrder: function(filterProducts) {
            const vanities = [];
            const sideCabinets = [];
            const sinks = [];
            const cabinets = [];
            const handles = [];
            const legs = [];
            const mirrors = [];
            const others = [];
            for (let i = 0; i < filterProducts.length; i++) {
                const cats = filterProducts[i].catFilters;
                if (cats[0] === 'vanities') {
                    vanities.push(filterProducts[i]);
                } else if (cats[0] === 'side-cabinets') {
                    sideCabinets.push(filterProducts[i]);
                } else if (cats[0] === 'sinks') {
                    sinks.push(filterProducts[i]);
                } else if (cats[0] === 'cabinets') {
                    cabinets.push(filterProducts[i]);
                } else if (cats[0] === 'handles') {
                    handles.push(filterProducts[i]);
                } else if (cats[0] === 'legs') {
                    legs.push(filterProducts[i]);
                } else if (cats[0] === 'mirrors' || cats[0] === 'led-mirror') {
                    mirrors.push(filterProducts[i]);
                } else {
                    others.push(filterProducts[i]);
                }
            }
            return vanities.concat(sideCabinets, sinks, cabinets, handles, legs, mirrors, others);
        },

        singleCategories: function(filterProducts) {
            const productsByCat = [];
            for (let i = 0; i < filterProducts.length; i++) {
                const cats = filterProducts[i].catFilters;
                if (cats.indexOf(this.sapCategory) !== -1) {
                    productsByCat.push(filterProducts[i]);
                }
            }
            return productsByCat;
        },

        reducingFilters(filterProducts) {
            let sizesSlugs = [];

            // cat arrays
            const newCatFiltersObj = [];
            const checkDuplicatesCat = [];

            // coll arrays
            const newCollFiltersObj = [];
            const checkDuplicatesColl = [];

            // color arrays
            const newColorFiltersObj = [];
            const checkDuplicatesColor = [];

            // style arrays
            const newStyleFiltersObj = [];
            const checkDuplicatesStyle = [];

            // type arrays
            const newTypeFiltersObj = [];
            const checkDuplicatesType = [];

            // brand arrays
            const newBrandFiltersObj = [];
            const checkDuplicatesBrand = [];

            // size arrays
            const newSizeFiltersObj = [];
            const checkDuplicatesSize = [];
            const checkDuplicatesRange = [];

            // width and length arrays
            const newWidthObj = [];
            const checkDuplicatesWidth = [];
            const newLengthObj = [];
            const checkDuplicatesLength = [];

            // height arrays
            const newHeightObj = [];
            const checkDuplicatesHeight = [];

            // depth arrays
            const newDepthObj = [];
            const checkDuplicatesDepth = [];

            if (filterProducts) {
                for (let i = 0; i < filterProducts.length; i++) {

                    // reduce product type filters
                    const toObjCat = this.toObject(filterProducts[i].catFiltersReduce);

                    if (toObjCat) {
                        for (const key in toObjCat) {
                            if (Object.prototype.hasOwnProperty.call(toObjCat, key)) {
                                const checkCat = checkDuplicatesCat.indexOf(toObjCat[key].slug) !== -1;
                                if (!checkCat) {
                                    newCatFiltersObj.push(toObjCat[key]);
                                }
                                checkDuplicatesCat.push(toObjCat[key].slug);
                            }
                        }
                    }

                    // reduce product collections filters
                    const toObjColl = this.toObject(filterProducts[i].collFiltersReduce);

                    if (toObjColl) {
                        for (const key in toObjColl) {
                            if (Object.prototype.hasOwnProperty.call(toObjColl, key)) {
                                const checkColl = checkDuplicatesColl.indexOf(toObjColl[key].slug) !== -1;
                                if (!checkColl) {
                                    newCollFiltersObj.push(toObjColl[key]);
                                }
                                checkDuplicatesColl.push(toObjColl[key].slug);
                            }
                        }
                    }

                    // colors
                    const toObjColor = this.toObject(filterProducts[i].colorFiltersReduce);
                    if (toObjColor) {
                        for (const key in toObjColor) {
                            if (Object.prototype.hasOwnProperty.call(toObjColor, key)) {
                                const checkColors = checkDuplicatesColor.indexOf(toObjColor[key].val) !== -1;
                                if (!checkColors) {
                                    newColorFiltersObj.push(toObjColor[key]);
                                }
                                checkDuplicatesColor.push(toObjColor[key].val);
                            }
                        }
                    }
                    // style
                    const styles = filterProducts[i].styleFilter;
                    if (styles) {
                        for (let s = 0; s < styles.length; s++) {
                            const checkStyles = checkDuplicatesStyle.indexOf(styles[s]) !== -1;
                            const objStyle = {
                                title: styles[s].replace(/-/g, ' '),
                                val: styles[s]
                            };
                            if (!checkStyles) {
                                newStyleFiltersObj.push(objStyle);
                            }
                            checkDuplicatesStyle.push(styles[s]);
                        }
                    }

                    // type
                    const types = filterProducts[i].typeFilter;
                    if (types) {
                        for (let t = 0; t < types.length; t++) {
                            const checkTypes = checkDuplicatesType.indexOf(types[t]) !== -1;
                            const objType = {
                                title: types[t].replace(/-/g, ' '),
                                val: types[t]
                            };
                            if (!checkTypes) {
                                newTypeFiltersObj.push(objType);
                            }
                            checkDuplicatesType.push(types[t]);
                        }
                    }

                    // brand
                    const brands = filterProducts[i].brandFilter;
                    if (brands) {
                        for (let b = 0; b < brands.length; b++) {
                            const checkBrands = checkDuplicatesBrand.indexOf(brands[b]) !== -1;
                            const objBrand = {
                                title: brands[b].replace(/-/g, ' '),
                                val: brands[b]
                            };
                            if (!checkBrands) {
                                newBrandFiltersObj.push(objBrand);
                            }
                            checkDuplicatesBrand.push(brands[b]);
                        }
                    }

                    const queryString = Global.getAllUrlParams();
                    const ranges = queryString.range ? queryString.range.split('+') : '';
                    let rangeNums = [];
                    if (ranges) {
                        for (let i = 0; i < ranges.length; i++) {
                            const min = ranges[i].split('-')[0];
                            const max = ranges[i].split('-')[1];
                            rangeNums = this.getRange(parseInt(min), parseInt(max), sizesSlugs);
                        }
                    }

                    const sizes = filterProducts[i].size;
                    if (sizes) {
                        for (let sz = 0; sz < sizes.length; sz++) {
                            const checkSizes = checkDuplicatesSize.indexOf(sizes[sz].slug) !== -1;
                            const checkRange = rangeNums.indexOf(sizes[sz].slug) !== -1;
                            let title = '';
                            if (sizes[sz].slug === 'unlimited') {
                                title = '++';
                            } else if (sizes[sz].range === true) {
                                title = sizes[sz].slug;
                            } else {
                                title = sizes[sz].slug.replace(/-/g, ' ');
                            }
                            const objSize = {
                                title: title,
                                val: sizes[sz].slug,
                                range: sizes[sz].range,
                                min: this.getMinMaxSize()[0],
                                max: this.getMinMaxSize()[1],
                                isStringRange: sizes[sz].is_string_range
                            };
                            sizesSlugs.push(sizes[sz].slug);
                            if (!checkSizes && ranges.length < 1) {
                                newSizeFiltersObj.push(objSize);
                            }
                            if (!checkRange && ranges.length > 0 && objSize.range !== true) {
                                newSizeFiltersObj.push(objSize);
                            }
                            checkDuplicatesSize.push(sizes[sz].slug);
                            checkDuplicatesRange.push(sizes[sz].slug);
                        }
                    }

                    const widths = filterProducts[i].width;
                    if (widths) {
                        for (let w = 0; w < widths.length; w++) {
                            const checkWidth = checkDuplicatesWidth.indexOf(widths[w]) !== -1;
                            const objWidth = {
                                title: widths[w] === 'unlimited' ? '++' : widths[w].replace(/-/g, ' '),
                                val: widths[w]
                            };
                            if (!checkWidth) {
                                newWidthObj.push(objWidth);
                            }
                            checkDuplicatesWidth.push(widths[w]);
                        }
                    }

                    const lengths = filterProducts[i].length;
                    if (lengths) {
                        for (let l = 0; l < lengths.length; l++) {
                            const checkLength = checkDuplicatesLength.indexOf(lengths[l]) !== -1;
                            const objLength = {
                                title: lengths[l] === 'unlimited' ? '++' : lengths[l].replace(/-/g, ' '),
                                val: lengths[l]
                            };
                            if (!checkLength) {
                                newLengthObj.push(objLength);
                            }
                            checkDuplicatesLength.push(lengths[l]);
                        }
                    }

                    const heights = filterProducts[i].height;
                    if (heights) {
                        for (let h = 0; h < heights.length; h++) {
                            const checkHeight = checkDuplicatesHeight.indexOf(heights[h]) !== -1;
                            const objHeight = {
                                title: heights[h] === 'unlimited' ? '++' : heights[h].replace(/-/g, ' '),
                                val: heights[h]
                            };
                            if (!checkHeight) {
                                newHeightObj.push(objHeight);
                            }
                            checkDuplicatesHeight.push(heights[h]);
                        }
                    }

                    const depths = filterProducts[i].depth;
                    if (depths) {
                        for (let d = 0; d < depths.length; d++) {
                            const checkDepth = checkDuplicatesDepth.indexOf(depths[d]) !== -1;
                            const objDepth = {
                                title: depths[d] === 'unlimited' ? '++' : depths[d].replace(/-/g, ' '),
                                val: depths[d]
                            };
                            if (!checkDepth) {
                                newDepthObj.push(objDepth);
                            }
                            checkDuplicatesDepth.push(depths[d]);
                        }
                    }
                }
            }
            newCatFiltersObj.sort(this.sortObjCat);
            this.productType[0].links = newCatFiltersObj;

            newCollFiltersObj.sort(this.sortObjCat);
            this.productCollections[0].links = newCollFiltersObj;

            newColorFiltersObj.sort(this.sortObj);
            this.productMaterial[0].material = newColorFiltersObj;

            newStyleFiltersObj.sort(this.sortObj);
            this.productStyle[0].links = newStyleFiltersObj;

            newTypeFiltersObj.sort(this.sortObj);
            this.productTypesAttr[0].links = newTypeFiltersObj;

            newBrandFiltersObj.sort(this.sortObj);
            this.productBrand[0].links = newBrandFiltersObj;

            newSizeFiltersObj.sort(this.sortObjSize);
            this.productSize[0].size = newSizeFiltersObj;

            newWidthObj.sort(this.sortObj);
            this.productWidth[0].width = newWidthObj;

            newLengthObj.sort(this.sortObj);
            this.productLength[0].productL = newLengthObj;

            newHeightObj.sort(this.sortObj);
            this.productHeight[0].productH = newHeightObj;

            newDepthObj.sort(this.sortObj);
            this.productDepth[0].productD = newDepthObj;


        },

        getRange: function(min, max, sizes) {
            const arr = [];
            const final = [];
            for (let i = min; i <= max; i++) {
                arr.push(i.toString());
            }

            for (let i = 0; i < sizes.length; i++) {
                if (arr.indexOf(sizes[i]) !== -1) {
                    final.push(sizes[i]);
                }
            }
            return final;
        },

        getMinMaxSize: function() {
            const activeFilters = Global.readCookie('activeFilters');
            const ranges = [];
            Global.setCookie('isRange', '');
            for (let i = 0; i < activeFilters.length; i++) {
                if (activeFilters[i].name === 'size' && activeFilters[i].val.indexOf('-') !== -1) {
                    Global.setCookie('isRange', true);
                    const min = activeFilters[i].val.split('-')[0];
                    const max = activeFilters[i].val.split('-')[1];
                    ranges.push(parseInt(min));
                    ranges.push(parseInt(max));
                }
            }

            return [Math.min.apply(Math, ranges), Math.max.apply(Math, ranges)];
        },

        compare(haystack, arr) {
            return arr.some(function(v) {
                return haystack.indexOf(v) >= 0;
            });
        },

        sortObj(a, b) {
            if (parseInt(a.val) < parseInt(b.val)) {
                return -1;
            }
            if (parseInt(a.val) > parseInt(b.val)) {
                return 1;
            }
            return 0;
        },

        sortObjCat(a, b) {
            if (parseInt(a.slug) < parseInt(b.slug)) {
                return -1;
            }
            if (parseInt(a.slug) > parseInt(b.slug)) {
                return 1;
            }
            return 0;
        },

        sortObjSize(a, b) {
            if (parseInt(a.val) < parseInt(b.val)) {
                return -1;
            }
            if (parseInt(a.val) > parseInt(b.val)) {
                return 1;
            }
            return 0;
        },

        toObject(arr) {
            const rv = {};
            if (arr) {
                for (let i = 0; i < arr.length; ++i) {
                    rv[i] = arr[i];
                }
            }
            return rv;
        },

        filterItems(arr, query) {
            return arr.filter(function(el) {
                return el.toLowerCase().indexOf(query.toLowerCase()) !== -1;
            });
        },

        pushToFiltersCookie(name, valAttr, addInfo, activeFilters) {
            const obj = {
                name: name,
                val: valAttr,
                addInfo: addInfo,
                title: name === 'size' ? valAttr : valAttr.replace(/-/g, ' '),
            };
            activeFilters.push(obj);
            Global.setCookie('activeFilters', activeFilters);
        },
        removeFromFilters(name, valAttr) {
            let filters = Global.readCookie('activeFilters');
            for (let i = 0; i < filters.length; i++) {
                if (filters[i].name === name && filters[i].val === valAttr) {
                    const index = filters.indexOf(filters[i]);
                    if (index > -1) {
                        filters = filters.splice(index, 1);
                    }
                }
            }
            Global.setCookie('activeFilters', filters);
        },

        objectLength(obj) {
            let size = 0;
            let key;
            for (key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) size++;
            }
            return size;
        },
    },
    data() {
        return {
            // eslint-disable-next-line no-undef
            sapData: sapData,
            // eslint-disable-next-line no-undef
            sapphirebathAjax: sapphirebathAjax,
            // eslint-disable-next-line no-undef
            sapCategory: sapCategory,
            // eslint-disable-next-line no-undef
            sapColl: sapColl,
            urlCustom: Global.readCookie('filters'),
            // eslint-disable-next-line no-undef
            isWidthAndLength: sapCategory === 'cabinets' || sapCategory === 'mirrors' || sapCategory === 'led-mirror',
        };
    },
    created() {
        EventBus.$on('trigger-results', event => {
            this.filtersLoad(event);
        });
    }
};
</script>

<style lang="scss" scoped>
.product-sidebar {
    padding-top: 48px;

    @include mq($md) {
        padding-top: 20px;
    }
}

.product-sidebar__inner {
    @include mq($md) {
        overflow-y: scroll;
        height: 100%;
        padding: 25px;
        max-height: calc(100vh - 160px);
    }

    // // iPhone X in portrait & landscape
    // @media only screen and (min-device-width : 375px) and (max-device-width : 812px) and (-webkit-device-pixel-ratio : 3) {
    //     padding-bottom: 80px;
    // }

    // // iPhone 6, 7, & 8 in portrait & landscape
    // @media only screen and (min-device-width : 375px) and (max-device-width : 667px)
    // {
    //     padding-bottom: 80px;
    // }

    // // iPhone 6, 7, & 8 Plus in portrait & landscape
    // @media only screen and (min-device-width : 414px) and (max-device-width : 736px) {
    //     padding-bottom: 80px;
    // }

    // // iPhone 5 & 5S in portrait & landscape
    // @media only screen and (min-device-width : 320px) and (max-device-width : 568px) {
    //     padding-bottom: 80px;
    // }

    @supports (-webkit-touch-callout: none) {
        padding-bottom: 80px;
    }
}

.product-sidebar__part {
    margin-bottom: 45px;

    @include mq($md) {
        margin-bottom: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid $white;
        max-width: 100%;
        width: 100%;

        &:last-of-type {
            border-bottom: none;
            margin-bottom: 0;
        }
    }
}

.product-sidebar__part--margin {
    margin-bottom: 33px;

    @include mq($md) {
        margin-bottom: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid $white;
    }
}

.product-sidebar__top {
    display: none;

    @include mq($md) {
        display: block;
        margin-bottom: 20px;
        position: relative;
        padding-right: 50px;
        padding-left: 25px;
    }
}

.product-sidebar__top-title {
    color: $dark-blue;
    font-family: $font-second;
    font-size: 18px;
    font-weight: 600;
    display: block;
    max-width: 100%;
    width: 100%;
    text-transform: uppercase;
    letter-spacing: .5px;
}

.product-sidebar__top-close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 22px;
    width: 20px;
    height: 20px;

    &:hover {
        &::before,
        &::after {
            transform: translate(-50%, -50%) rotate(0);
            transition: $dur $ease;
        }
    }

    &::before,
    &::after {
        content: '';
        @include center;
        height: 2px;
        width: 15px;
        background-color: $dark-blue;
        transition: $dur $ease;
    }

    &::before {
        transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
        transform: translate(-50%, -50%) rotate(-45deg);
    }
}
</style>
